/**
 * AcceptPlatformInvitationRoute — router-level dispatcher for the
 * PUBLIC `/accept-platform-invitation` flow (SCRUM-131).
 *
 * The platform-staff invitation email link is fixed at
 * `${FE_URL}/accept-platform-invitation?token=…` (see
 * `apps/api/src/modules/identity/infrastructure/email/
 * smtp-email.renderer.ts`), so this is the single FE entry point for
 * platform invitations. It COEXISTS with the org `/accept-invitation`
 * route — do not conflate the two.
 *
 * The dispatcher only reads the `?token` query param and hands it down.
 * Token validation, preview, and accept all live in
 * AcceptPlatformInvitationConsumePage so the consume page is testable
 * in isolation without a Router context.
 */

import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import { AcceptPlatformInvitationConsumePage } from './AcceptPlatformInvitationConsumePage.js';

export function AcceptPlatformInvitationRoute(): React.ReactElement {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  return <AcceptPlatformInvitationConsumePage token={token} />;
}
